import { createFileRoute } from '@tanstack/react-router';

import { ErrorPage } from '@/components/errors';

export const Route = createFileRoute('/error/404')({
  component: NotFoundError,
});

function NotFoundError() {
  return <ErrorPage status={404} />;
}
